export default __webpack_public_path__ + "static/anjana_story-8cee70b31990e91f08fcb76ab1c23b45.png";